/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import { Vector4Tuple } from 'three';

export const isVector4Tuple = (p: any): p is Vector4Tuple =>
  Array.isArray(p) &&
  p.length === 4 &&
  typeof p[0] === 'number' &&
  typeof p[1] === 'number' &&
  typeof p[2] === 'number' &&
  typeof p[3] === 'number';
